import {
	LinkRampBillToPurchaseOrderMutation,
	UnlinkRampBillFromPurchaseOrderMutation
} from "~/gql/mutations/rampInvoices.generated";
import { RequestRampPurchaseOrderCopyMutation } from "~/gql/mutations/rampPurchaseOrderCopy.generated";
import {
	GetRampPurchaseOrderInvoicesQuery,
	GetUnlinkedRampBillsForPurchaseOrderQuery
} from "~/gql/queries/rampInvoices.generated";
import { GetRampPurchaseOrderCopyQuery } from "~/gql/queries/rampPurchaseOrderCopy.generated";

export const rampInvoiceEndpoints = {
	GetRampPurchaseOrderCopy: {
		providesTags: ["RampPurchaseOrderCopy"] as AddTagTypes,
		transformResponse: (res: GetRampPurchaseOrderCopyQuery) => res
	},
	GetRampPurchaseOrderInvoices: {
		providesTags: ["RampPurchaseOrderInvoices"] as AddTagTypes,
		transformResponse: (res: GetRampPurchaseOrderInvoicesQuery) => res
	},
	GetUnlinkedRampBillsForPurchaseOrder: {
		providesTags: ["RampPurchaseOrderInvoices"] as AddTagTypes,
		transformResponse: (res: GetUnlinkedRampBillsForPurchaseOrderQuery) => res
	},
	LinkRampBillToPurchaseOrder: {
		invalidatesTags: ["RampPurchaseOrderInvoices"] as AddTagTypes,
		transformResponse: (res: LinkRampBillToPurchaseOrderMutation) => res
	},
	RequestRampPurchaseOrderCopy: {
		invalidatesTags: ["RampPurchaseOrderCopy"] as AddTagTypes,
		transformResponse: (res: RequestRampPurchaseOrderCopyMutation) => res
	},
	UnlinkRampBillFromPurchaseOrder: {
		invalidatesTags: ["RampPurchaseOrderInvoices"] as AddTagTypes,
		transformResponse: (res: UnlinkRampBillFromPurchaseOrderMutation) => res
	}
};
